<template>

    <div>

        <toolbar :title="(googleConnected) ? 'Google-Account' : 'Anmelden'"></toolbar>

          <v-divider></v-divider>

            <v-responsive>
                <v-card-text >

                    <v-container class="pa-0">


                        <v-layout row wrap v-if="!googleConnected">

                            <v-flex xs12>

                                <p>Um alle Einstellungen und Daten, auch über mehrere Geräte hinweg, dauerhaft zu speichern, melden Sie sich bitte an. Wenn Sie dies nutzen, wird ein Cookie im Browser gespeichert.</p>

                            </v-flex>

                            <v-flex xs12>

                                <div id="gSignInWrapper">
                                    <v-btn
                                          color="white black--text"
                                          id="googleLoginButton"
                                        >
                                        <v-icon left color="grey" class="icon-google"></v-icon>
                                        Mit Google anmelden
                                    </v-btn>
                                  </div>

                            </v-flex>

                        </v-layout>


                        <v-layout row wrap v-if="googleConnected">

                            <v-flex xs12>

                                <p>Sie sind angemeldet als:<br><strong>{{ gName }} ({{ gEmail }})</strong></p>

                                <p>Alle Einstellungen und Daten werden für diesen Zugang gespeichert.</p>

                                <p></p>

                            </v-flex>

                            <v-flex xs12>

                                <p>Um gespeicherte Einstellungen und Daten für die App zu löschen, können Sie die Verbindung zum Google-Account jederzeit trennen.</p>

                            </v-flex>

                            <v-flex xs12>

                                <v-dialog
                                      v-model="dialog"
                                      width="500"
                                    >
                                        <v-btn
                                              slot="activator"
                                              color="red white--text"
                                              id="googleDisconnectButton"
                                            >
                                            Verbindung zu Google trennen
                                        </v-btn>



                                        <v-card>
                                            <v-card-title
                                                class="headline"
                                                primary-title
                                            >
                                                Verbindung zum Google-Account trennen?
                                            </v-card-title>

                                            <v-card-text>
                                            Ihre Einstellungen und Daten für diese App werden gelöscht.
                                            </v-card-text>

                                            <v-divider></v-divider>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>

                                                <v-btn
                                                    color="error"
                                                    depressed
                                                    @click="btnDisconnect"
                                                >
                                                    Löschen &amp; Trennen
                                                </v-btn>

                                                <v-btn
                                                    depressed
                                                    @click="dialog=false"
                                                >
                                                    Abbrechen
                                                </v-btn>


                                            </v-card-actions>
                                        </v-card>

                                    </v-dialog>

                            </v-flex>

                        </v-layout>





                    </v-container>

                </v-card-text>

            </v-responsive>
    </div>


</template>

<script>
    export default {
        name: 'anmelden',
        data: () => ({
            /**
           * The Auth2 parameters, as seen on
           * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
           * As the very least, a valid client_id must present.
           * @type {Object}
           */
            dialog: false,
          googleSignInParams: {
            client_id: '849822970072-k1a0mp2v7i64r9bgg8ml6bvlfdn72b1g.apps.googleusercontent.com'
          }
        }),

        computed: {
            googleConnected() {
                return this.$store.getters.gIsLoggedIn
            },

            gName() {
                return this.$store.getters.gName;
            },

            gEmail() {
                return this.$store.getters.gEmail;
            }
        },

        methods: {

            btnDisconnect() {

                // Verbindung zum Google Account aufheben
                this.$store.dispatch("deleteAccount");

                //const vue = this;
                let auth2 = gapi.auth2.getAuthInstance();
                auth2.disconnect().then(function () {
                  console.log("User disconnectedt.");
                  window.location.reload();
                });

            }

        },

        beforeCreate() {

            if ( this.$store.getters.gIsLoggedIn === false ) {

                this.$getGapiClient()
                    .then(gapi => {
                        gapi.auth2.getAuthInstance()
                            .then(authInstance => {
                                authInstance.attachClickHandler(
                                    'googleLoginButton',
                                    {},
                                    function(googleUser) {
                                        console.log("Signed in: " + googleUser.getBasicProfile().getName());
                                        window.location.reload();
                                    }, function(error) {
                                        /*if ( error.type === "") {

                                        }*/
                                        console.log("google", JSON.stringify(error, undefined, 2));
                                    }
                            );

                        })
                });
            }


        }
    }
</script>

<style scoped>

    /*.g-signin-button {
      !* This is where you control how the button looks. Be creative! *!
      display: inline-block;
      padding: 4px 8px;
      border-radius: 3px;
      background-color: #3c82f7;
      color: #fff;
      box-shadow: 0 3px 0 #0f69ff;
    }*/

</style>
